import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

import Login from "../screens/login/Login";
import ManageProfile from "../screens/ManageProfile/ManageProfile";
import AddProfile from "../screens/AddProfile/AddProfile";
import EditProfile from "../screens/EditProfile/EditProfile";
import District from "../screens/district/district";
import Testimonials from "../screens/testimonials/testimonials";

const Routes = () => {
  return (
    <>
      <Switch>
        <Route path="/login" component={Login} exact />
        <PrivateRoute path="/" component={ManageProfile} exact />
        <PrivateRoute path="/addprofile" component={AddProfile} />
        <PrivateRoute path="/editprofile/:id" component={EditProfile} />
        <PrivateRoute path="/district" component={District} />
        <PrivateRoute path="/testimonials" component={Testimonials} />
        <Redirect from="*" to={"/"} />
      </Switch>
    </>
  );
};

export default Routes;
